
<div id="app-workflows-stage-todo-sd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main"
    [attr.aria-label]="('WORKFLOWCREATE' | translate)">
    <app-headline [type]="'h4'" [class]="'text-muted fw-bold m-0 pe-2'"
        [title]="('WORKFLOWSTAGETITLE' | translate)"></app-headline>
    <div class="card mb-3 d-flex flex-column overflow-hidden">
        <div class="card-body d-flex flex-column ps-3 py-3 pe-1 h-100">
            <!-- Toolbar -->
            <div class="d-flex justify-content-between align-items-center">
                <app-form-button [text]="'BACK' | translate" (click)="true" [icon]="'chevron_left'"
                    [iconPosition]="'left'" [cssClass]="'e-outline e-small fw-semibold align-middle'"
                    [iconClass]="'fs-5'"></app-form-button>
                <div class="d-flex align-items-center gap-1">
                    <app-headline [type]="'h6'" [class]="'text-orange fw-bold'"
                        [title]="'WORKFLOWTODOUNFINALIZEDSTATE' | translate"></app-headline>
                    <app-tooltip [tooltipTarget]="'.saveform-icon'" [text]="('WORKFLOWSAVEPROGRESSTOOLTIP' | translate)"
                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                        <app-form-button (click)="true"
                            [cssClass]="'saveform-icon e-btn e-flat fs-normal text-primary p-1'" [icon]="'save'"
                            [iconClass]="'fs-4 mts-icon-filled  m-1'"></app-form-button>
                    </app-tooltip>
                </div>
            </div>

            <!-- Scrollable content-->
            <div class="custom-scrollbar overflow-y-auto pe-2 mt-2">
                <!--WORKFLOW DETAILS CARD -->
                <div class="card workflowCard brd-success">
                    <div class="card-body">
                        <div class="d-flex justify-content-end">
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                    [bgColor]="'bg-transparent'" [border]="true" [brdColor]="'brd-muted'"
                                    [rounded]="false">Description</app-pill>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center flex-wrap gap-2 mb-3 pt-2">
                                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                    [title]="'Workflow title'"></app-headline>
                            </div>
                            <div [class.d-none]="!isStageExpanded" class="d-flex my-2">
                                <app-content [type]="'richtext'"
                                    [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                            </div>
                            <div [class.d-none]="!isStageExpanded"
                                class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION
                                (WHERE IIT IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE
                                WHICH YOU CAN FIND UNDER THIS TEXT
                                <!--<ng-container *ngFor="let file of files; let i = index">
                                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                                </ng-container>-->
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex align-items-center gap-4 flex-wrap">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Expires
                                        at:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                        [fontDecoration]="'fw-bold'">18.05.2025</app-content>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'"
                                        [fontColor]="'text-muted'">Type:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-danger'"
                                        [fontDecoration]="'fw-bold'">Confidential</app-content>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add requester button -->
                <div class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <!-- Only add the bottom line if there is another stage fallowing-->
                    <div *ngIf="true" style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- REQUESTER STAGE AS ACTIVE TASK-->
                <div class="card workflowCard" [class.active_stage]="true">
                    <div class="card-header">
                        <div class="d-flex align-items-center justify-content-center">
                            <app-headline [title]="('WORKFLOWYOURTASKTEXT' | translate)" [type]="'h6'"
                                [class]="'fw-bold text-white'"></app-headline>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-end">
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                    [bgColor]="'bg-transparent'" [border]="true" [brdColor]="'brd-primary'"
                                    [rounded]="false">Requester</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>

                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 col-12 col-md-6">
                                            <app-form-dropdown [fG]="workflowStageForm" [fCN]="'dropdown_choice'"
                                                [dataSource]="dropdown_datasource" [placeholder]="'SELECT' | translate"
                                                [marker]="'priority'"></app-form-dropdown>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'" [maxChars]="250"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-form-textarea [placeholder]="('WORKFLOWTEXTPLACEHOLDER' | translate)"
                                                [fCN]="'workflow_text'" [fG]="workflowStageForm" [maxChars]="250"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date-time [fG]="workflowStageForm" [fCN]="'datetime_answer'"
                                                    [disabled]="false"></app-form-date-time>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date [fG]="workflowStageForm" [fCN]="'date_asnwer'"
                                                    [disabled]="false"></app-form-date>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-time [fG]="workflowStageForm"
                                                    [fCN]="'timeStart'"></app-form-time>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-dialog-documents-upload [view]="'component'"
                                                    [(files)]="attachmentFiles" [multiple]="true"
                                                    [type]="'both'"></app-dialog-documents-upload>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- If requires mandatory comment -->
                                    <div class="d-flex flex-column my-3 w-100">
                                        <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                            [maxChars]="250"
                                            [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"
                                            [class]="'text-primary'"></app-form-label>
                                        <app-form-textarea
                                            [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                            [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                            [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="250"
                                            [rows]="4"></app-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-end align-items-center">
                            <app-form-button [text]="'WORKFLOWFINALIZESTAGEBUTTON' | translate" (click)="true"
                                [cssClass]="'e-btn e-primary e-small fw-semibold'"></app-form-button>
                        </div>
                    </div>
                </div>
                <!-- Stage connector -->
                <!-- Only add the bottom line if there is another stage fallowing-->
                <div *ngIf="true" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- REQUESTER STAGE VIEWD BY OTHER STAGES-->
                <div class="card workflowCard brd-success">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1 gap-1 ">
                                <app-icon-badge [style]="'default'" [icon]="'task_alt'" [fontSize]="'fs-5'"
                                    [fontColor]="'text-success'"></app-icon-badge>
                                <app-headline [title]="'RQ.'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                    [bgColor]="'bg-transparent'" [border]="true" [brdColor]="'brd-primary'"
                                    [rounded]="false">Requester</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>

                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column gap-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Radio label 1</app-content>
                                                </div>
                                            </div>
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Radio label 2</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Radio label 3</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Radio label 4</app-content>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-muted'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-success'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-muted'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"
                                                [enabled]="false"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" [disabled]="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 d-flex flex-column gap-2">
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-success'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">Dropdown choice 1</app-content>
                                            </div>
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'"
                                                    [fontColor]="'text-muted'">Dropdown choice 2</app-content>
                                            </div>
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'"
                                                    [fontColor]="'text-muted'">Dropdown choice 3</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column gap-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Checkbox label 1</app-content>
                                                </div>
                                            </div>
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Checkbox label 2</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Checkbox label 3</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Checkbox label 4</app-content>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">13.06.2026 15:34:00</app-content>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">13.06.2026</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">15:34:00</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <!-- List of Files-->
                                        <div class="d-flex flex-wrap mt-2 mb-1 gap-2 uploadedFilesContainer">
                                            PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY
                                            QUESTION (WHERE IIT IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE
                                            COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS TEXT
                                            <!--<ng-container *ngFor="let file of files; let i = index">
                                                <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                                            </ng-container>-->
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- If requires mandatory comment -->
                                    <div class="d-flex flex-column my-3 gap-1">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                            [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [fontDecoration]="'fw-bold'">Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor. Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor.</app-content>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex align-items-center gap-4 flex-wrap">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Created
                                        at:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                        [fontDecoration]="'fw-bold'">18.05.2025</app-content>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Requested
                                        by:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                        [fontDecoration]="'fw-bold'">Carsten Jobmann - UFU</app-content>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Stage connector -->
                <!-- Only add the bottom line if there is another stage fallowing-->
                <div *ngIf="true" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- TASK/TEAM TASK STAGE AS ACTIVE TASK-->
                <div class="card workflowCard" [class.active_stage]="true">
                    <div class="card-header">
                        <div class="d-flex align-items-center justify-content-center">
                            <app-headline
                                [title]="('WORKFLOWYOURTASKTEXT' | translate) + ' - ' + ('WORKFLOACTIVETASKDUETEXT' | translate) + ' : 18.07.2025'"
                                [type]="'h6'" [class]="'fw-bold text-white'"></app-headline>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-end">
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-success'"
                                    [bgColor]="'bg-faintgreen'" [border]="true" [brdColor]="'brd-success'"
                                    [rounded]="false">Task / Team Task</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If one users was selected in the Stage Settings -->
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                    <!-- If there is specific group/users who were selected to work as a team -->
                                    <app-form-button (click)="onOpenDialog($event,'show-workflowteamparticipants')"
                                        [cssClass]="'e-btn e-outline p-0 e-verysmall e-simple'"
                                        [text]="('WORKFLOWSTAGESHOWTEAMPARTICIPANTS' | translate)"></app-form-button>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowStageForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowStageForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 col-12 col-md-6">
                                            <app-form-dropdown [fG]="workflowStageForm" [fCN]="'dropdown_choice'"
                                                [dataSource]="dropdown_datasource" [placeholder]="'SELECT' | translate"
                                                [marker]="'priority'"></app-form-dropdown>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowStageForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="250"
                                                [currentChars]="workflowStageForm.controls['workflow_text'].value.length"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-form-textarea [placeholder]="('WORKFLOWTEXTPLACEHOLDER' | translate)"
                                                [fCN]="'workflow_text'" [fG]="workflowStageForm" [maxChars]="250"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date-time [fG]="workflowStageForm" [fCN]="'datetime_answer'"
                                                    [disabled]="false"></app-form-date-time>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date [fG]="workflowStageForm" [fCN]="'date_asnwer'"
                                                    [disabled]="false"></app-form-date>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-time [fG]="workflowStageForm"
                                                    [fCN]="'timeStart'"></app-form-time>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                                [maxChars]="200"
                                                [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-dialog-documents-upload [view]="'component'"
                                                    [(files)]="attachmentFiles" [multiple]="true"
                                                    [type]="'both'"></app-dialog-documents-upload>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- If requires mandatory comment -->
                                    <div class="d-flex flex-column my-3 w-100">
                                        <app-form-label [class]="'text-primary'"
                                            [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate" [maxChars]="250"
                                            [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"></app-form-label>
                                        <app-form-textarea
                                            [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                            [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                            [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="250"
                                            [rows]="4"></app-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-end align-items-center gap-2">
                            <app-form-button [text]="'WORKFLOWSAVECHANGESBUTTON' | translate" (click)="true"
                                [cssClass]="'e-btn e-success e-small fw-semibold'"></app-form-button>
                            <app-form-button [text]="'WORKFLOWFINALIZESTAGEBUTTON' | translate" (click)="true"
                                [cssClass]="'e-btn e-primary e-small fw-semibold'"></app-form-button>
                        </div>
                    </div>
                </div>
                <!-- Stage connector -->
                <!-- Only add the bottom line if there is another stage fallowing or the fallowing stage is not toggled hidden-->
                <div *ngIf="stageShow" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- TASK/TEAM TASK STAGE VIEWD BY OTHER STAGES-->
                <div *ngIf="stageShow" class="card workflowCard brd-success">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1 gap-1 ">
                                <app-icon-badge [style]="'default'" [icon]="'task_alt'" [fontSize]="'fs-5'"
                                    [fontColor]="'text-success'"></app-icon-badge>
                                <app-headline [title]="'ST1.'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <app-tooltip [tooltipTarget]="'.stage-hide'"
                                    [text]="('WORKFLOWSTAGEHIDETOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="toggleStageVisibility()"
                                        [cssClass]="'stage-hide e-btn e-flat fs-normal text-muted p-1'"
                                        [icon]="'visibility_off'"
                                        [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                </app-tooltip>
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.workflow-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'workflow-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.workflow-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'workflow-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-success'"
                                    [bgColor]="'bg-faintgreen'" [border]="true" [brdColor]="'brd-success'"
                                    [rounded]="false">Task / Team Task</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If one users was selected in the Stage Settings -->
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                    <!-- If there is specific group/users who were selected to work as a team -->
                                    <app-form-button (click)="onOpenDialog($event,'show-workflowstageparticipants')"
                                        [cssClass]="'e-btn e-outline p-0 e-verysmall e-simple'"
                                        [text]="('WORKFLOWSTAGESHOWTEAMPARTICIPANTS' | translate)"></app-form-button>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column gap-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Radio label 1</app-content>
                                                </div>
                                            </div>
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Radio label 2</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Radio label 3</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Radio label 4</app-content>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-muted'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-success'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                            [fontSize]="'fs-4'"
                                                            [fontColor]="'text-muted'"></app-icon-badge>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"
                                                [enabled]="false"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" [disabled]="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 d-flex flex-column gap-2">
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-success'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">Dropdown choice 1</app-content>
                                            </div>
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'"
                                                    [fontColor]="'text-muted'">Dropdown choice 2</app-content>
                                            </div>
                                            <div class="d-flex align-items-center gap-1">
                                                <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                    [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                <app-content [fontSize]="'fs-default'"
                                                    [fontColor]="'text-muted'">Dropdown choice 3</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column gap-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Checkbox label 1</app-content>
                                                </div>
                                            </div>
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                            <div class="d-flex flex-column gap-2">
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Checkbox label 2</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'check_circle'"
                                                        [fontSize]="'fs-5'"
                                                        [fontColor]="'text-success'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                        [fontDecoration]="'fw-bold'">Checkbox label 3</app-content>
                                                </div>
                                                <div class="d-flex align-items-center gap-1">
                                                    <app-icon-badge [style]="'default'" [icon]="'cancel'"
                                                        [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Checkbox label 4</app-content>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">13.06.2026 15:34:00</app-content>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">13.06.2026</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                    [fontDecoration]="'fw-bold'">15:34:00</app-content>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <!-- List of Files-->
                                        <div class="d-flex flex-wrap mt-2 mb-1 gap-2 uploadedFilesContainer">
                                            PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY
                                            QUESTION (WHERE IIT IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE
                                            COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS TEXT
                                            <!--<ng-container *ngFor="let file of files; let i = index">
                                               <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                                           </ng-container>-->
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 gap-1">
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                                [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                                [fontDecoration]="'fw-bold'">Evaluate management efficiency by
                                                completing this survey, lorem ipsum dolor. Evaluate management
                                                efficiency by completing this survey, lorem ipsum dolor.</app-content>
                                        </div>
                                    </div>

                                    <!-- If requires mandatory comment -->
                                    <div class="d-flex flex-column my-3 gap-1">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                            [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [fontDecoration]="'fw-bold'">Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor. Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor.</app-content>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Stage connector with Show/Hide Stage toggle-->
                <div *ngIf="!stageShow" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <app-form-button [style]="'btn'" [text]="('WORKFLOWSHOWSTAGEBUTTON' | translate) + ' ' + 'ST.1'"
                        (click)="toggleStageVisibility()" [icon]="'visibility'" [iconPosition]="'left'"
                        [cssClass]="'rounded-pill bg-aqua text-white p-2'"
                        [iconClass]="'fs-4 text-white'"></app-form-button>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- Only add the bottom line if there is another stage fallowing or the fallowing stage is not toggled hidden-->
                <div *ngIf="stageShow" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!-- REVIEW STAGE AS ACTIVE TASK-->
                <div class="card workflowCard" [class.active_stage]="true">
                    <div class="card-header">
                        <div class="d-flex align-items-center justify-content-center">
                            <app-headline
                                [title]="('WORKFLOWYOURTASKTEXT' | translate) + ' - ' + ('WORKFLOACTIVETASKDUETEXT' | translate) + ' : 18.07.2025'"
                                [type]="'h6'" [class]="'fw-bold text-white'"></app-headline>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-end">
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-pill [fontColor]="'text-orange'" [fontSize]="'fs-default'" [border]="true"
                                    [bgColor]="'bg-faintorange'" [brdColor]="'brd-orange'"
                                    [rounded]="false">Review</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If one users was selected in the Stage Settings -->
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>

                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <div class="d-flex align-items-center justify-content-center my-3 gap-5">
                                        <button class="e-btn e-success e-small py-2 px-3"><span
                                                class="fs-default fw-bold">ACCEPT</span></button>
                                        <button class="e-btn e-danger e-small py-2 px-3"><span
                                                class="fs-default fw-bold">REJECT</span></button>
                                    </div>

                                    <!-- Show only after the Reviewer clicked a button-->
                                    <div class="d-flex flex-column my-3">
                                        <div class="d-flex justify-content-center">
                                            <!-- If ACCEPTED -->
                                            <app-pill [bgColor]="'bg-success'"
                                                [fontSize]="'fs-6'">{{'WORKFLOWREVIEWSTAGEACCEPTEDD' |
                                                translate}}</app-pill>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <!-- IF REJECTED-->
                                            <app-pill [bgColor]="'bg-danger'"
                                                [fontSize]="'fs-6'">{{'WORKFLOWREVIEWSTAGEREJECTED' |
                                                translate}}</app-pill>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column my-3 w-100">
                                        <app-form-label [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"
                                            [maxChars]="250"
                                            [currentChars]="workflowStageForm.controls['workflow_comment'].value.length"
                                            [class]="'text-primary'"></app-form-label>
                                        <app-form-textarea
                                            [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                            [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                            [fCN]="'workflow_comment'" [fG]="workflowStageForm" [maxChars]="250"
                                            [rows]="4"></app-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Footer is only needed if there is a textarea to fill by the reviewer-->
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-end align-items-center">
                            <app-form-button [text]="'WORKFLOWFINALIZESTAGEBUTTON' | translate" (click)="true"
                                [cssClass]="'e-btn e-primary e-small fw-semibold'"></app-form-button>
                        </div>
                    </div>
                </div>
                <!-- Stage connector -->
                <!-- Only add the bottom line if there is another stage fallowing-->
                <div *ngIf="true" class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                    <div style="width: 2px; height: 20px;" class="bg-aqua"></div>
                </div>
                <!--  REVIEW STAGE AS VIEWD BY OTHER STAGES-->
                <div class="card workflowCard brd-success">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1 gap-1 ">
                                <app-icon-badge [style]="'default'" [icon]="'task_alt'" [fontSize]="'fs-5'"
                                    [fontColor]="'text-success'"></app-icon-badge>
                                <app-headline [title]="'ST2.'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <app-pill [fontColor]="'text-orange'" [fontSize]="'fs-default'" [border]="true"
                                    [bgColor]="'bg-faintorange'" [brdColor]="'brd-orange'"
                                    [rounded]="false">Review</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If one users was selected in the Stage Settings -->
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <!-- Composed Form Container -->
                                <div class="d-flex flex-column my-3">
                                    <div class="d-flex justify-content-center">
                                        <!-- If ACCEPTED -->
                                        <app-pill [bgColor]="'bg-success'"
                                            [fontSize]="'fs-6'">{{'WORKFLOWREVIEWSTAGEACCEPTEDD' |
                                            translate}}</app-pill>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <!-- IF REJECTED-->
                                        <app-pill [bgColor]="'bg-danger'"
                                            [fontSize]="'fs-6'">{{'WORKFLOWREVIEWSTAGEREJECTED' | translate}}</app-pill>
                                    </div>
                                    <!-- If requires mandatory comment -->
                                    <div class="d-flex flex-column my-3 gap-1">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                            [fontDecoration]="'fw-bold'">Mandatory Comment:</app-content>
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [fontDecoration]="'fw-bold'">Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor. Evaluate management efficiency by completing
                                            this survey, lorem ipsum dolor.</app-content>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dialogs">
        <!-- Dialog for Team Participants -->
        <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #showAllTeamParticipants
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' #showEventParticipantsDialog
            [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'"
            [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true">
            <ng-template #header>
                <div class="d-flex align-items-center justify-content-center">
                    <app-headline [title]="('WORKFLOWSTAGEPARTICIPANTSTITLE' | translate)" [type]="'h5'"
                        [class]="'text-primary'"></app-headline>
                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                        [text]="('WORKFLOWSTAGEPARTICIPANTSHELP' | translate)" [width]="'300px'" [height]="'100px'"
                        [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
                </div>
            </ng-template>
            <ng-template #content>
                <div class="d-flex flex-column h-100 p-3">
                    <app-form-input [placeholder]="('SEARCHFORUSER' | translate)" [iconFront]="'search'"
                        [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_user_string'"
                        [fG]="workflowStageForm"></app-form-input>
                    <h6 class="text-center text-secondary">Participant could not be found!</h6>
                    <div class="py-2 d-flex align-items-center justify-content-end flex-wrap gap-2">
                        <app-form-dropdown [fG]="workflowStageForm" [fCN]="'workflowInitationConversation'"
                            [dataSource]="workflowparticipantsInitiateConversation"
                            [placeholder]="'SELECTOPTIONS' | translate" [popupWidth]="'auto'"
                            [cssClass]="'small-filter-dropdown'">
                        </app-form-dropdown>
                    </div>
                    <!-- SCrollable content-->
                    <div class="custom-scrollbar overflow-y-auto">
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>

                                <div
                                    class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                                    <app-form-checkbox [fG]="workflowStageForm" [fCN]="'chat_with_participant'"
                                        [cssClass]="'pb-1'"></app-form-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>

                                <div
                                    class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                                    <app-form-checkbox [fG]="workflowStageForm" [fCN]="'chat_with_participant'"
                                        [cssClass]="'pb-1'"></app-form-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>

                                <div
                                    class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                                    <app-form-checkbox [fG]="workflowStageForm" [fCN]="'chat_with_participant'"
                                        [cssClass]="'pb-1'"></app-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-dialog>

        <!-- Dialog for Stage Participants -->
        <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #showAllStageParticipants
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' #showEventParticipantsDialog
            [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'"
            [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true">
            <ng-template #header>
                <div class="d-flex align-items-center justify-content-center">
                    <app-headline [title]="('WORKFLOWSTAGEPARTICIPANTSTITLE' | translate)" [type]="'h5'"
                        [class]="'text-primary'"></app-headline>
                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                        [text]="('WORKFLOWSTAGEPARTICIPANTSHELP' | translate)" [width]="'300px'" [height]="'100px'"
                        [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
                </div>
            </ng-template>
            <ng-template #content>
                <div class="d-flex flex-column h-100 p-3">
                    <app-form-input [placeholder]="('SEARCHFORUSER' | translate)" [iconFront]="'search'"
                        [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_user_string'"
                        [fG]="workflowStageForm"></app-form-input>
                    <h6 class="text-center text-secondary">Participant could not be found!</h6>
                    <!-- SCrollable content-->
                    <div class="custom-scrollbar overflow-y-auto">
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-dialog>
    </div>
</div>
